import type { ComponentEntry } from '../../foundry-shared/chart-component-catalog';
import { BAR_COMPONENT_ID, defaultBarConfig } from './bar-chart.model';
export const UNIFIED_BAR_ENTRY:ComponentEntry={
  id:BAR_COMPONENT_ID,label:'Bar / column',category:'chart-components',subcategory:'unified-bar',icon:'bar_chart',
  inputs:['data'],requiredInputs:[],selector:'app-unified-bar-chart',types:['unified-bar'],sourcePath:'lib/chart-components/unified-bar-chart/unified-bar-chart.component.ts',sampleSourcePath:'assets/design-builder/bar-charts/vertical.json',
  defaultConfig:defaultBarConfig(),load:()=>import('./unified-bar-chart.component').then(m=>m.UnifiedBarChartComponent),
};
